export default __webpack_public_path__ + "static/burlingame-58a23649ea7965dc51912308f59f81bb.png";